import { isUserInternational } from './regions';

export const convertToQid = (id: number, countryCode?: string): string => {
  let identifier = 'Q';
  if (countryCode && isUserInternational(countryCode)) {
    identifier = 'I';
  }
  return identifier.concat(id.toString().padStart(5, '0'));
};

/**
 * Parse QID string (e.g. "Q00045", "I00010") to numeric user id.
 * QID starts with Q or I followed by digits. Returns NaN if invalid.
 */
export const parseQidToUserId = (qid: string): number => {
  if (!qid || typeof qid !== 'string') {
    return NaN;
  }
  const trimmed = qid.trim();
  const first = trimmed.charAt(0).toUpperCase();
  if ((first !== 'Q' && first !== 'I') || trimmed.length < 2) {
    return NaN;
  }
  const num = Number(trimmed.slice(1));
  return Number.isInteger(num) && num >= 0 ? num : NaN;
};

export const getEnrollmentTextTranslation = (statusText: string): string => {
  const statusDict:{ [key: string]: string } = {
    approved: 'trialdetails.statusApproved',
    cancelled: 'trialdetails.statusCancelled',
    applied: 'trialdetails.statusApplied',
    rejected: 'trialdetails.statusRejected',
  };
  return statusDict[statusText.toLocaleLowerCase()] || 'trialdetails.unknownEnrollmentStatus';
};
